import { COLUMN_TYPE, MATCHING_TIME_PERIODS } from '../../../../../../constants/generalConstants';
import { ColumnMetadataType, PeriodType } from '../../../../../../types';
import { SUPPORTED_FIELD_VALUES } from '../../../../constants';

export function getSupportedPeriods(colsMetadata: ColumnMetadataType[]): PeriodType[] {
    const report = colsMetadata.find((col) => col.contentType === COLUMN_TYPE.REPORT && col.reportProps?.period);
    let supportedPeriods = SUPPORTED_FIELD_VALUES.PERIODS;
    if (report) {
        const matchingPeriods = MATCHING_TIME_PERIODS.find((periods) => periods.includes(report.reportProps!.period!));

        if (matchingPeriods) {
            supportedPeriods = supportedPeriods.filter((p) => !matchingPeriods.includes(p));
            supportedPeriods = [...matchingPeriods, ...supportedPeriods];
        }
    }

    return supportedPeriods;
}
